import styled from 'styled-components';

const OverflowingImage = styled.img`
  position: relative;
  width: ${props => `${props.widthFraction * 100}vw`};
  margin-left: ${props => `calc(-${(props.widthFraction * 100) / 2}vw + 50%)`};
`;

export default OverflowingImage;
